"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVariantPropertyOption = exports.isVariantProperty = exports.variantPropertyDefinition = void 0;
const variantPropertyOptions = [
    'Edition',
    'Energy Drink',
    'Sugarfree',
    'Sugarfree Edition',
    'Zero',
];
exports.variantPropertyDefinition = {
    name: 'variant',
    type: 'select',
    constraints: [
        {
            name: 'options',
            argument: variantPropertyOptions,
        },
    ],
    multiple: false,
    view: {
        label: 'Variant',
        style: '',
    },
};
const isVariantProperty = (prop) => {
    return prop.name === exports.variantPropertyDefinition.name;
};
exports.isVariantProperty = isVariantProperty;
const isVariantPropertyOption = (option) => {
    return variantPropertyOptions.includes(option);
};
exports.isVariantPropertyOption = isVariantPropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFyaWFudC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3ZhcmlhbnQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsTUFBTSxzQkFBc0IsR0FBRztJQUM3QixTQUFTO0lBQ1QsY0FBYztJQUNkLFdBQVc7SUFDWCxtQkFBbUI7SUFDbkIsTUFBTTtDQUNFLENBQUE7QUFFRyxRQUFBLHlCQUF5QixHQUFHO0lBQ3ZDLElBQUksRUFBRSxTQUFTO0lBQ2YsSUFBSSxFQUFFLFFBQVE7SUFDZCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFLHNCQUFzQjtTQUNqQztLQUNGO0lBQ0QsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsU0FBUztRQUNoQixLQUFLLEVBQUUsRUFBRTtLQUNWO0NBQzhCLENBQUE7QUFJMUIsTUFBTSxpQkFBaUIsR0FBRyxDQUFDLElBQWtCLEVBQTJCLEVBQUU7SUFDL0UsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGlDQUF5QixDQUFDLElBQUksQ0FBQTtBQUNyRCxDQUFDLENBQUE7QUFGWSxRQUFBLGlCQUFpQixxQkFFN0I7QUFJTSxNQUFNLHVCQUF1QixHQUFHLENBQUMsTUFBYyxFQUFtQyxFQUFFO0lBQ3pGLE9BQVEsc0JBQTRDLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFBO0FBQ3ZFLENBQUMsQ0FBQTtBQUZZLFFBQUEsdUJBQXVCLDJCQUVuQyJ9